export const Config = {
    loginUrl: () => {     
        return `${window.PBM_API_URL}auth`
    },
    
    captchaUrl: () => {     
        return `${window.PBM_API_URL}captcha`
    },

//----------------------------TENANTS------------------------------------------------
    tenantsUrl: () => {        
        return `${window.PBM_API_URL}tenants`
    },  
    tenantsActionUrl: (id) => {
        // const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}tenants/${id}`
    },

//----------------------------DOMAINS------------------------------------------------
    domainsUrl: () => {
       const tenant = localStorage.getItem('tenant')
       return `${window.PBM_API_URL}maildomains/${tenant}`
    },
    domainsAddEditDelUrl: (domain) => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}maildomains/${tenant}/${domain}`
    },   

//----------------------------USERS------------------------------------------------
    usersUrl: (page, search, sort, orderby, attrs) => {
       const tenant = localStorage.getItem('tenant')
        const searchString = search ? `&search=${search}` : ""
        const sortTodisplay = sort ? `&sort=${sort}` : ""
        const orderbyTodisplay = orderby ? `&orderby=${orderby}` : ""
        const attrsTodisplay = attrs ? `&attrs=${attrs}` : ""
        const pageNum = page*1
       return `${window.PBM_API_URL}users/${tenant}?page=${pageNum}${searchString}${sortTodisplay}${orderbyTodisplay}${attrsTodisplay}`
    },
    userUrl: (tenantId, email) => {
       const tenant = localStorage.getItem('tenant')
       return `${window.PBM_API_URL}users/${tenant}/${email}`
    }, 
    editDeleteUserUrl: (mail) =>{
      const tenant = localStorage.getItem('tenant')
      return `${window.PBM_API_URL}users/${tenant}/${mail}`
   },
    avatarUrl: (mail) => {
      const tenant = localStorage.getItem('tenant')
      return `${window.PBM_API_URL}avatars/${tenant}/${mail}`
    },     

//----------------------------CALENDARS------------------------------------------------ 
    calendarsUrl: (email) => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}calendars/${tenant}/${email}`
    },  
    
       
//----------------------------RESOURCES_GROUPS------------------------------------------------     
   groupsUrl: () => {
      const tenant = localStorage.getItem('tenant')
      return `${window.PBM_API_URL}resourcegroups/${tenant}`
   },    
   deleteGroupUrl: (groupName) => {
       const tenant = localStorage.getItem('tenant')
       return `${window.PBM_API_URL}resourcegroups/${tenant}/${groupName}`
   },
   addGroupUrl: (name) => {
       const tenant = localStorage.getItem('tenant')
       return `${window.PBM_API_URL}resourcegroups/${tenant}/${name}`
    },
   renameGroupUrl: (groupName) => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}resourcegroups/${tenant}/${groupName}`
    },   
//----------------------------RESOURCES------------------------------------------------  
    resourcesUrl: (groupName) => {
       const tenant = localStorage.getItem('tenant')
       return `${window.PBM_API_URL}resources/${tenant}/${groupName}`
    },
    editDeleteResourceUrl: (resourceMail, groupName) =>{
       const tenant = localStorage.getItem('tenant')
       return `${window.PBM_API_URL}resources/${tenant}/${groupName}/${resourceMail}`
   },
    
   groupResourcesUrl: (groupName, mail) => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}resources/${tenant}/${groupName}/${mail}`
    },
    updateResourceUrl: (groupName, mail) => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}resources/${tenant}/${groupName}/${mail}`
    },
    
//----------------------------MAILLISTS------------------------------------------------      
    maillistsUrl: () => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}maillists/${tenant}`
    },
    newMaillistsUrl: (mail) => {
        const tenant = localStorage.getItem('tenant')
        return `${window.PBM_API_URL}maillists/${tenant}/${mail}`
    },
}

